import { useEffect, useState, createRef, useCallback } from 'react';
import useInvalidations from '../atoms/text-input/use-invalidation.hook';
export const mapInvalidIndexToField = (invalidations, names, refs) => names.reduce((acc, name, i) => {
    acc[name] = { isInvalid: invalidations[i], ref: refs && refs[i] };
    return acc;
}, {});
export const getSettingsWithValidation = (model) => {
    const res = [];
    Object.entries(model).forEach(([key, value]) => {
        if (value?.invalidationsMap) {
            res.push(key);
        }
    });
    return res;
};
export const getSettingsToCheck = (model, settingNames) => settingNames.map((name) => ({
    [name]: model[name].invalidationsMap,
}));
export const isRefSettingValid = (setting) => {
    const k = Object.keys(setting)[0];
    return Object.values(setting[k]).every((v) => !v.isInvalid);
};
export const isSettingValid = (setting) => {
    const k = Object.keys(setting)[0];
    return Object.values(setting[k]).every((v) => v === false);
};
export const getFirstInvalidElement = (settings) => {
    for (let i = 0; i < settings.length; i++) {
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        const inputs = Object.values(Object.values(settings[i])[0]);
        for (let j = 0; j < inputs.length; j++) {
            if (inputs[j].isInvalid && inputs[j].ref) {
                return inputs[j].ref.current;
            }
        }
    }
    return null;
};
export const useRefs = (count) => {
    const [refs, setRefs] = useState(Array(count).fill(undefined));
    useEffect(() => {
        setRefs(refs.map(createRef));
    }, []);
    return refs;
};
export const validateModel = (model) => {
    const settingsWithValidation = getSettingsWithValidation(model);
    const settingsToCheck = getSettingsToCheck(model, settingsWithValidation);
    const invalidElement = getFirstInvalidElement(settingsToCheck);
    const isAllSettingsValid = settingsToCheck.every(isRefSettingValid);
    const isAllValid = model.isNameValid !== false &&
        model.isInstanceNameValid !== false &&
        isAllSettingsValid;
    if (!isAllValid) {
        if (model.isNameValid === false || model.isInstanceNameValid === false) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }
        else {
            invalidElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return false;
    }
    return true;
};
export const useInputsValidators = (fieldsToValidate, update) => {
    const [refs] = useState(() => {
        const theRefs = [];
        // ref available both by index and by fieldName
        fieldsToValidate.forEach((fieldName, i) => {
            const ref = createRef();
            theRefs[i] = ref;
            theRefs[fieldName] = ref;
        });
        return theRefs;
    });
    const { invalidations, onInvalidate, setInvalidations } = useInvalidations({
        inputs: fieldsToValidate.length,
    });
    const invalidationsMap = mapInvalidIndexToField(invalidations, fieldsToValidate, refs);
    const onInvalidateWrapper = useCallback((field) => {
        const index = typeof field === 'string' ? fieldsToValidate.indexOf(field) : field;
        return onInvalidate(index);
    }, [fieldsToValidate, onInvalidate]);
    useEffect(() => {
        update('invalidationsMap', (p) => ({
            ...p,
            ...invalidationsMap,
        }));
    }, [...invalidations]);
    fieldsToValidate.forEach((value, index) => {
        invalidations[value] = invalidations[index];
    });
    return {
        refs,
        onInvalidate: onInvalidateWrapper,
        invalidations,
        setInvalidations,
    };
};
export const useRemoveValidationOnUnmount = (fields, update) => {
    useEffect(() => () => update('invalidationsMap', (p) => {
        const newMap = { ...p };
        // eslint-disable-next-line no-restricted-syntax
        for (const field of fields) {
            newMap[field] = {
                isInvalid: false,
            };
        }
        return newMap;
    }), []);
};
